var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgCongratulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 96,
    viewBox: "0 0 198 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.27,
    cy: 49.7271,
    rx: 33.027,
    ry: 32.9066,
    fill: "#148740"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.6 41.2384C113.096 41.7326 113.096 42.534 112.6 43.0283L97.8061 57.7684C97.062 58.5098 95.8556 58.5098 95.1115 57.7684L87.9389 50.6221C87.4429 50.1278 87.4429 49.3265 87.9389 48.8322C88.435 48.3379 89.2393 48.3379 89.7354 48.8322L96.4588 55.5311L110.804 41.2384C111.3 40.7441 112.104 40.7441 112.6 41.2384Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.513 27.9491L192.619 28.587C192.921 26.0979 194.946 24.1672 197.447 23.9892C194.946 23.8112 192.921 21.8805 192.619 19.3914L192.513 20.0292C192.157 22.1774 190.387 23.809 188.217 23.9892C190.387 24.1694 192.157 25.801 192.513 27.9491Z",
    fill: "#148740",
    stroke: "#148740",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M4.85065 66.7751L4.95636 67.4129C5.25835 64.9238 7.28291 62.9931 9.78399 62.8151C7.28291 62.6371 5.25835 60.7064 4.95636 58.2173L4.85065 58.8552C4.49468 61.0033 2.72464 62.6349 0.554688 62.8151C2.72464 62.9953 4.49468 64.6269 4.85065 66.7751Z",
    fill: "#148740",
    stroke: "#148740",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.615 10.5086L137.732 11.2174C138.068 8.45166 140.317 6.30647 143.096 6.1087C140.317 5.91092 138.068 3.76573 137.732 1L137.615 1.70874C137.219 4.09556 135.252 5.90844 132.841 6.1087C135.252 6.30895 137.219 8.12183 137.615 10.5086Z",
    fill: "#FFD058",
    stroke: "#FFD058",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.3069 87.3795L54.9059 87.3369L54.3069 87.2942C50.4863 87.0223 47.3944 84.0804 46.9331 80.2779L46.8598 79.6738L46.6836 80.7369C46.0903 84.3172 43.1403 87.0365 39.5237 87.3369C43.1403 87.6373 46.0903 90.3566 46.6836 93.9368L46.8598 94.9999L46.9331 94.3958C47.3944 90.5933 50.4863 87.6514 54.3069 87.3795Z",
    fill: "#148740",
    stroke: "#148740",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.606 65.4699L161.759 66.3913C162.195 62.7958 165.12 60.0071 168.732 59.7499C165.12 59.4928 162.195 56.7041 161.759 53.1086L161.606 54.03C161.092 57.1329 158.536 59.4896 155.401 59.7499C158.536 60.0103 161.092 62.367 161.606 65.4699Z",
    fill: "#FFD058",
    stroke: "#FFD058",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4376 27.9491L28.5433 28.587C28.8453 26.0979 30.8698 24.1672 33.3709 23.9892C30.8698 23.8112 28.8453 21.8805 28.5433 19.3914L28.4376 20.0292C28.0816 22.1774 26.3116 23.809 24.1416 23.9892C26.3116 24.1694 28.0816 25.801 28.4376 27.9491Z",
    fill: "#FFD058",
    stroke: "#FFD058",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCongratulations);
export default __webpack_public_path__ + "static/media/img_congratulations.d2a9f5a8629b8af3ebcd6dcd89a2d72c.svg";
export { ForwardRef as ReactComponent };